export const SET_ROWS = 'SET_ROWS';
export const CREATE_ROWS = 'CREATE_ROWS';
export const SET_TEXTS = 'SET_TEXTS';
export const SET_PITS = 'SET_PITS';
export const SET_IMAGES = 'SET_IMAGES';
export const SELECT_ENTITIES = 'SELECT_ENTITIES';
export const UNSELECT_ENTITIES = 'UNSELECT_ENTITIES';
export const CREATE_ENTITIES = 'CREATE_ENTITIES';
export const ON_PLACEHOLDER_ONE_ROW_ONE_SEAT = 'ON_PLACEHOLDER_ONE_ROW_ONE_SEAT';
export const SAVE_ENTITIES = 'SAVE_ENTITIES';
export const TOGGLE_SHOW_LABELS = 'TOGGLE_SHOW_LABELS';
export const REMOVE_ENTITIES = 'REMOVE_ENTITIES';
export const CHANGE_LABEL_ROW = 'CHANGE_LABEL_ROW';
export const CHANGE_LABEL_MULTIPLE_ROWS = 'CHANGE_LABEL_MULTIPLE_ROWS';
export const CHANGE_CURVE_ROW = 'CHANGE_CURVE_ROW';
export const CHANGE_SEQUENCE_ROW = 'CHANGE_SEQUENCE_ROW';
export const CHANGE_SEQUENCE_OFFSET_ROW = 'CHANGE_SEQUENCE_OFFSET_ROW';
export const CHANGE_LABEL_TEXT = 'CHANGE_LABEL_TEXT';
export const CHANGE_FONT_SIZE_TEXT = 'CHANGE_FONT_SIZE_TEXT';
export const ASSIGN_ENTITIES_CATEGORY = 'ASSIGN_ENTITIES_CATEGORY';
export const HOVER_SEAT = 'HOVER_SEAT';
export const UNHOVER_SEAT = 'UNHOVER_SEAT';
export const ON_SELECT_SEAT = 'ON_SELECT_SEAT';
export const SET_SEAT_TEXT = 'SET_SEAT_TEXT';
export const REMOVE_SEAT_TEXT = 'REMOVE_SEAT_TEXT';
export const UPDATE_SELECTION_PROPS = 'UPDATE_SELECTION_PROPS';
export const SET_SELECTION_PROPS = 'SET_SELECTION_PROPS';
export const SET_SELECTION_PIVOT_LOCATION = 'SET_SELECTION_PIVOT_LOCATION';
export const SET_DUPLICATED_SEATS_COUNT = 'SET_DUPLICATED_SEATS_COUNT';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const CHANGE_IMAGE_RATIO = 'CHANGE_IMAGE_RATIO';
export const ON_CHANGE_ZOOM = 'ON_CHANGE_ZOOM';
export const ON_CHANGE_TRANSLATE = 'ON_CHANGE_TRANSLATE';
export const SET_LOADER = 'SET_LOADER';
export const SET_PICKER_SELECTION = 'SET_PICKER_SELECTION';
export const SET_PICKER_MODE = 'SET_PICKER_MODE';
export const ON_SELECT_PIT = 'ON_SELECT_PIT';
export const ON_UNSELECT_PIT = 'ON_UNSELECT_PIT';
export const ON_UNSELECT_SEAT = 'ON_UNSELECT_SEAT';
export const DELETE_SELECTION = 'DELETE_SELECTION';
export const DUPLICATE_SELECTION = 'DUPLICATE_SELECTION';
export const CHANGE_SEATS_COUNT = 'CHANGE_SEATS_COUNT';
export const SET_PITS_PROPS = 'SET_PITS_PROPS';
export const SET_TEXTS_DESCRIPTION = 'SET_TEXTS_DESCRIPTION';
export const UPDATE_DESCRIPTION_TEXT = 'UPDATE_DESCRIPTION_TEXT';

export class GraphicEvents {

    constructor() {
        this.init();
    }

    init() {
        this.callbacks = [];
    }

    on(name, callback) {
        if (!this.callbacks[name]) this.callbacks[name] = [];
        this.callbacks[name].push(callback);
    }

    remove(name, callback) {
        if (!this.callbacks[name]) return;
        const index = this.callbacks[name].indexOf(callback);
        if (index !== -1) {
            this.callbacks[name].splice(index, 1);
        }
    }

    trigger(name, params = null) {
        if (this.callbacks[name]) {
            this.callbacks[name].forEach(callback => callback(params));
        }
    }

    removeAll(name) {
        this.callbacks[name] = []
    }
}

export const graphicEvents = new GraphicEvents();